import { PayloadAction } from '@reduxjs/toolkit';

import { getLineItem } from '../../logic/line-item';
import { WritableAutoConfiguratorState } from '../slice';
import { revalidateFieldValuePreservingParseErrors } from '../validation/apply-validation';

type Payload = {
  lineItemUuid: string;
  quantityBreakUuid: string;
};

export function deleteQuantityBreak(
  state: WritableAutoConfiguratorState,
  action: PayloadAction<Payload>,
) {
  const { lineItemUuid, quantityBreakUuid } = action.payload;

  // Get line item
  const lineItem = getLineItem(state, lineItemUuid);

  // Find quantity break
  const index = lineItem.quantityBreakUuids.indexOf(quantityBreakUuid);

  if (index < 0) {
    throw new Error(
      `Expected line item "${lineItemUuid}" to have quantity break "${quantityBreakUuid}"`,
    );
  }

  // Remove from line item's list of quantity break UUIDs
  lineItem.quantityBreakUuids.splice(index, 1);

  // Delete from quantityBreaks state
  delete state.quantityBreaks[quantityBreakUuid];

  // The breaks on either side of the removed one are now neighbors, so their
  // quantity ordering errors may be stale
  for (const neighborIndex of [index - 1, index]) {
    if (neighborIndex < 0) {
      continue;
    }

    const neighborUuid = lineItem.quantityBreakUuids[neighborIndex];

    if (!neighborUuid) {
      continue;
    }

    revalidateFieldValuePreservingParseErrors(
      state,
      { model: 'quantityBreak', key: 'quantity' },
      { model: 'quantityBreak', key: 'quantity', uuid: neighborUuid },
    );
  }
}
